import { DeliverySegment } from "../../../types/schedule/delivery-segment";
import { DeliverySegmentDto } from "../../../types/schedule/delivery-segment-dto";

export const convertDeliverySegmentDtoToDeliverySegment = (
  deliverySegmentDto: DeliverySegmentDto
): DeliverySegment => {
  return {
    id: deliverySegmentDto.id,
    type: deliverySegmentDto.type,
  };
};
